module.exports = __webpack_public_path__ + "static/media/corporate-services-img34.7e37e86d.jpg";